import React from 'react';
import { IVisitorSummaryPageContainerRouteParams } from './types';
import { useParams } from 'react-router-dom';
import AjaxErrorBoundary from '../../ajax/errorBoundary';
import VisitorSummaryPage from './VisitorSummaryPage';
import { useDataFetcher } from '../../hooks';
import { IVisitorSummaryPageProps } from './types';

const toUkDateTime = (value: string): string => {
  const dateFromString = new Date(value);

  return `${dateFromString.toLocaleDateString(
    'en-GB',
  )} @ ${dateFromString.toLocaleTimeString('en-GB', { hour12: false })}`;
};

const transformData = (
  summary: IVisitorSummaryPageProps,
): IVisitorSummaryPageProps => ({
  ...summary,
  inAt: toUkDateTime(summary.inAt),
  outAt: summary.outAt ? toUkDateTime(summary.outAt) : 'Currently signed in',
});

const config = { transformer: transformData };

const VisitorSummaryPageContainer: React.FC = () => {
  const { visitorId } = useParams<IVisitorSummaryPageContainerRouteParams>();

  const { busy, data, errors } = useDataFetcher(
    `/api/visitors/${visitorId}`,
    config,
  );

  return (
    <AjaxErrorBoundary
      busy={busy}
      errors={errors}
      loadingText="Loading visitor details"
    >
      <VisitorSummaryPage {...data} />
    </AjaxErrorBoundary>
  );
};

export default VisitorSummaryPageContainer;
